export default "__VITE_ASSET__wSOYajps__"